import React, { useEffect, useState } from 'react'

import { usePageData } from '../../../hooks'
import { Carousel } from '../../Carousel'
import { CategoryCaption } from './CategoryCaption'

import './ProjectCategory.scss'

const ProjectCategory = ({ categoryName }) => {
  const [categorySlides, setCategorySlides] = useState([])
  const { loading, pageData, currentRoute } = usePageData()

  useEffect(() => {
    const categorySet = pageData &&
      pageData.filter((projectData = {}) => {
        const projectCategory = projectData.category && projectData.category.toLowerCase
          ? projectData.category.replace('/', ' ') : ''
        return categoryName === 'all' ||
          projectCategory.toLowerCase() === categoryName
            .replace('+', ' ')
            .toLowerCase()
      })
    const categorySetName = categorySet && categorySet[0] && categorySet[0].category
    document.title = `${ currentRoute && currentRoute.pageTitle } : ${ categorySetName }`
    setCategorySlides(categorySet)
  }, [pageData, currentRoute, categoryName])

  return(
    <div className="project-category">
      { loading &&
        <div>loading...</div>
      }
      { !loading && categorySlides &&
        <Carousel
          className="project-category__carousel"
          onSlideChange={ (val) => console.log(val) }
          overlay={ CategoryCaption(categorySlides) }
          loading={ loading }
          slides={ categorySlides }
        />
      }
    </div>
  )
}

export default ProjectCategory

